<template>
<div class="col-lg-6 my-2 bh-cursor" @click="goCurse">
    <div class="b-white shadow-sm border rounded card-curse">
        <b-card-img :src="cover" class="rounded-0 float-left"></b-card-img>
        <div class="info p-3 float-left">
            <div class="font-blue font-weight-bold">
                {{title}}
            </div>
            <small>Curso Kllaar</small> <br>
            <small>Precio $ {{curse.price}}.00</small> <br>
            <img src="@/assets/icons/kllaar_gray.png" alt="" height="20"><span class="font-weight-bold font-gray-dark p-1">Kllaar.com</span>
        </div>
    </div>
    <!-- <b-card no-body class="curse overflow-hidden border-0 shadow-sm" @click="goCurse">
        <b-row no-gutters>
        <b-col md="6">
            <b-card-img :src="cover" class="rounded-0"></b-card-img>
        </b-col>
        <b-col md="6">
            <b-card-body :title="title">
            <b-card-text>
                <RatingMin :rating="rating" :students="students"/>
                <small class="font-gray-dark">
                    {{description.substring(0 , 50) + "..."}}
                </small>
            </b-card-text>
            </b-card-body>
        </b-col>
        </b-row>
    </b-card> -->
</div>
</template>
<style scoped>
@media only screen and (min-width : 320px) {
*{
    font-size: 10px;
}
.card-curse{
    max-height: 200px;
    min-height: 100px;
    overflow: hidden;
    
}
.card-curse img{
    max-height: 200px;
    max-width: 150px;
}
}
@media only screen and (min-width : 550px) {
    *{
        font-size: 14px;
    }
}
@media only screen and (min-width : 1200px) {
.card-curse{
    max-height: 150px;
    min-height: 150px;
    overflow: hidden;
}
.card-curse img{
    max-height: 230px;
    max-width: 230px;
}
}

    
    /* .curse{
        max-height: 150px;
        max-width: 340px;
        margin: 10px;
    }
    .curse img{
        min-height: 150px;        
    }
    h4{
        font-size: 14px;
    }
    .curse:hover{
        cursor:pointer;
        opacity: .7;
    } */

</style>
<script>
import RatingMin from './RatingMin'
export default {
    components:{
        'RatingMin': RatingMin
    },
    props:{
        cover: String,
        title: String,
        description: String,
        rating: Number,
        students: Number,
        name: String,
        lname: String,
        url_public: String,
        curse: Object
    },
    methods:{
        goCurse(){
            this.$router.push('/curse/view/' + this.url_public)
            //this.$router.go()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/#public/curse/components/home/CurseMini.vue